import {gql} from '@apollo/client'

export const GET_INFO_DASHBOARD = gql`
  query reportDashboard($initialDate: Date!, $endDate: Date!) {
    reportDashboard(initialDate: $initialDate, endDate: $endDate) {
      quantitySales
      quantitySalesClose
      totalSales
      products {
        product
        soldValue
      }
    }
  }
`
export const GET_MOTNH_INFO = gql`
  query reportDashboardMonth($initialDate: Date!, $endDate: Date!) {
    reportDashboard(initialDate: $initialDate, endDate: $endDate) {
      quantitySales
      quantitySalesClose
      totalSales
      products {
        product
        soldValue
      }
    }
  }
`
